/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
   /*
   * AFE モール刺しゅう糸
   * 画像スライドと色バリエーションの連動
   */
  function afeSyncVariantFromMedia(section, mediaVariantMap, media) {
    if (!media) return false;

    var mediaId = String(
      media.getAttribute('data-media-id') || ''
    );
    if (!mediaId) return false;

    var optionValue = '';

    for (var i = 0; i < mediaVariantMap.length; i++) {
      if (String(mediaVariantMap[i].mediaId) === mediaId) {
        optionValue = String(mediaVariantMap[i].optionValue);
        break;
      }
    }

    /* 共通画像の場合は選択色を変更しない */
    if (!optionValue) return false;

    var radioInputs = section.querySelectorAll(
      'input[type="radio"][value]'
    );

    for (var j = 0; j < radioInputs.length; j++) {
      if (String(radioInputs[j].value) === optionValue) {
        if (!radioInputs[j].checked) {
          radioInputs[j].click();
        }
        return true;
      }
    }

    return false;
  }

  function afeInitMediaVariantSync() {
    var mapElements = document.querySelectorAll(
      '[data-afe-media-variant-map]'
    );

    for (var i = 0; i < mapElements.length; i++) {
      var mapElement = mapElements[i];
      var section = mapElement.closest('.shopify-section');

      if (!section || section.dataset.afeMediaSyncReady === 'true') {
        continue;
      }

      var mediaVariantMap;

      try {
        mediaVariantMap = JSON.parse(mapElement.textContent);
      } catch (error) {
        console.warn(
          'AFE media/variant map could not be read.',
          error
        );
        continue;
      }

      section.dataset.afeMediaSyncReady = 'true';

      (function(sectionElement, variantMap) {
        var updatePending = false;

        function checkSelectedSlide() {
          if (updatePending) return;
          updatePending = true;

          window.requestAnimationFrame(function() {
            updatePending = false;

            var selectedItems = sectionElement.querySelectorAll(
              '.is-selected'
            );

            for (var j = 0; j < selectedItems.length; j++) {
              var selectedItem = selectedItems[j];
              var media = null;

              if (selectedItem.hasAttribute('data-media-id')) {
                media = selectedItem;
              } else {
                media = selectedItem.querySelector(
                  '[data-media-id]'
                );
              }

              if (
                afeSyncVariantFromMedia(
                  sectionElement,
                  variantMap,
                  media
                )
              ) {
                return;
              }
            }
          });
        }

        var observer = new MutationObserver(function(mutations) {
          for (var j = 0; j < mutations.length; j++) {
            if (mutations[j].attributeName === 'class') {
              checkSelectedSlide();
              return;
            }
          }
        });

        observer.observe(sectionElement, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
        });

        checkSelectedSlide();
      })(section, mediaVariantMap);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      afeInitMediaVariantSync
    );
  } else {
    afeInitMediaVariantSync();
  }
})();
